import { createConsumer } from "@rails/actioncable";
import GwtTokenStorage from "../utils/gwt_token_storage.js";
import { camelizeKeys } from "../utils/utils.js"

class BaseChannel {

  static initConsumerIfNeed = () => {
    if(window.consumer) {
      return;
    }
    let consumer = createConsumer(`/cable?jwt_token=${GwtTokenStorage.get()}`);
    window.consumer = consumer;
  }

  static reloadConsumer = () => {
    const { consumer } = window;
    if(consumer) {
      consumer.disconnect();
      window.consumer = undefined;
    }
    BaseChannel.initConsumerIfNeed();
  }

  subscribe = (onDataReceived) => {
    BaseChannel.initConsumerIfNeed();

    const { consumer: { subscriptions } } = window;

    this.channel = subscriptions.create(this.channelName(), {
      received(data) {
        if(onDataReceived) {
          onDataReceived(camelizeKeys(data));
        }
      }
    });
  }

  unsubscribe = () => {
    if(!this.channel) {
      return;
    }
    
    this.channel.unsubscribe();
  }

  channelName = () => {
    return "";
  }

}

export default BaseChannel;